import {
  AppInsightsContext,
  MetadataContext,
  ModuleBase,
  ReportsGrid,
  TrackEventKey,
  UserContext,
  TrackEventType,
  TrackEventName,
} from '@/components';
import {
  CognitiveFilterRequestModel,
  ModuleBaseModel,
  ModuleBasePropsModel,
  ReportSearchModel,
  UiConfigurationModel,
  ReportCardType,
  LinkModel,
} from '@/types';
import { useRouter } from 'next/router';
import { useContext } from 'react';

type ReportsGridModuleModel = ModuleBaseModel<
  {
    heading: string;
    headingTag: string;
    description: string;
    anchor: string;
    uiConfiguration: UiConfigurationModel;
    requestFilter?: CognitiveFilterRequestModel;
    cards: ReportSearchModel[];
    cardType: ReportCardType;
    link?: LinkModel;
  } & ModuleBasePropsModel
>;

const ReportsGridModule = (data: ReportsGridModuleModel) => {
  const { props } = data;

  const { pageId } = useContext(MetadataContext);
  const appInsights = useContext(AppInsightsContext);
  const user = useContext(UserContext);
  const router = useRouter();

  const onCardClick = (e: React.MouseEvent, data: ReportSearchModel) => {
    appInsights.trackCustomEvent(TrackEventName.REPORT, TrackEventKey.REPORTS_GRID, TrackEventType.SELECTED, user, {
      pageId,
      pagePath: router.asPath,
      reportID: data.reportId,
    });
  };

  return (
    <ModuleBase data={{ ...data, props: { ...props, noPaddingOnTop: true } }} className="overflow-hidden">
      <div className="mx-auto">
        <ReportsGrid
          uiConfiguration={props.uiConfiguration}
          cards={props.cards}
          cardType={props.cardType}
          requestFilter={props.requestFilter}
          heading={{
            heading: props.heading,
            headingTag: props.headingTag,
            description: props.description,
            link: props.link,
          }}
          onCardClick={onCardClick}
        />
      </div>
    </ModuleBase>
  );
};

export default ReportsGridModule;
